module.exports = __webpack_public_path__ + "media/images/front/event_235-9de78f33100cf10ef51489400720a30a.jpg";